import React from 'react';

const HistoryItem = ({ title, id, status, onClick }) => {
  const embedUrl = `https://www.youtube.com/embed/${id}`;

  return (
    <div style={styles.container} onClick={onClick}>
      <div style={styles.details}>
        <p style={styles.title} >{title}</p>
        <div style={styles.videoContainer}>
          <iframe
            src={embedUrl}
            title={title}
            style={styles.iframe}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <p style={styles.status}>Status: {status}</p>
      </div>
      {/* <div style={styles.actions}>
        <button style={styles.button}>Delete</button>
        <button style={styles.button}>Share</button>
      </div> */}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  details: {
    flex: 1,
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  videoContainer: {
    marginBottom: '10px',
    position: 'relative',
    paddingTop: '56.25%', // Aspect ratio 16:9
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // padding: '10px',
  },
  status: {
    fontSize: '16px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  button: {
    backgroundColor: '#555',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    padding: '10px 20px',
    cursor: 'pointer',
  },
};

export default HistoryItem;
